module.exports = __webpack_public_path__ + "static/media/profile.9960d83e.svg";